import { Tag } from 'antd';
import { observer } from 'mobx-react-lite';
import React, { Dispatch, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { PermissionAuthority } from '../../../../permissions/PermissionAuthority';
import authoritiesStore from '../../../../stores/authoritiesStore';
import rolesStore from '../../../../stores/rolesStore';
import { mergeAuthorities } from '../../../../utils/functionAuthorities';
import { transformToValueLabel } from '../../../../utils/functions';
import CheckboxComponent from '../../../atoms/CheckboxComponent';
import InputComponent from '../../../atoms/InputComponet';
import PermissionComponent from '../../../atoms/PermissionComponent';
import SelectComponent from '../../../atoms/SelectComponent';
import SwitchComponent from '../../../atoms/SwitchComponent';
import ContentBox from '../../../molecules/ContentBox';
import Permission from '../../../molecules/Permission';
import './styles.scss';
import { useFormikContext } from 'formik';
import administratorStore from '../../../../stores/administratorStore';

interface FormAdministratorProps {
    setSelectedItems: Dispatch<any>;
    selectedItems: any;
    permissions: any;
    setPermissions: Dispatch<any>;
    setRole: Dispatch<any>;
}

const FormAdministrator: React.FC<FormAdministratorProps> = observer(({ selectedItems, setRole, setSelectedItems, setPermissions, permissions }) => {
    const { uuid } = useParams<{ uuid: string }>();
    const { authoritiesList } = authoritiesStore;
    const { rolesList } = rolesStore
    const uniqueGroups = [...new Set(authoritiesList.filter((auth: any) => auth.show).map((auth: any) => auth.groupedBy))];
    const sortedItems = [...uniqueGroups].sort((a: any, b: any) => a.localeCompare(b));
    const sortedItemsPermission = [...permissions].sort((a: any, b: any) => a.description.localeCompare(b.description));
    const { childEligibleParent } = administratorStore;
    const { setFieldValue } = useFormikContext<any>();

    const handleGroupClick = (group: any) => {
        const permissionsForSelectedGroup = authoritiesList.filter((auth: any) => auth.groupedBy === group && auth.show === true);
        setPermissions(permissionsForSelectedGroup);
    };

    const countItemsInGroup = (group: string) => {
        return selectedItems?.filter((item: any) => item.groupedBy === group).length;
    };

    const onChangeSelect = (option: any) => {
        setSelectedItems(mergeAuthorities(option?.option));

        if (option?.option?.hierarchy) {
            administratorStore.getEligibleParent(option?.option?.hierarchy);
        }
        setFieldValue('parentAdministrator', null);
    }

    return (
        <>
            <ContentBox className="mb-4 p-6" borderCustom='rounded-b-lg' title="Cadastro de Administradores" description='Tela para cadastro de Administradores' actions={
                <SwitchComponent name="active" checkedChildren="Ativo" unCheckedChildren="Inativo" />
            }>
                <div className="flex gap-3 mb-3">
                    <InputComponent label="Nome" name="name" id="name" />
                    <InputComponent disabled={uuid ? true : false} label="Usuário*" name="username" id="username" />
                    <InputComponent disabled={uuid ? true : false} label="E-mail*" name="email" id="email" />
                </div>
                <div className="grid grid-cols-12 gap-3 mb-3">
                    {!uuid ? <div className="col-span-4">
                        <InputComponent label="Confirmar E-mail*" name="confirmEmail" id="confirmEmail" />
                    </div> : <></>}
                    <div className="col-span-4">
                        <SelectComponent
                            label="Cargo"
                            name="role"
                            options={transformToValueLabel(rolesList, "uuid", "name")}
                            onChange={(value, option) => onChangeSelect(option)}
                        />
                    </div>
                    <div className="col-span-4">
                        <SelectComponent
                            label="Administrador Pai"
                            name="parentAdministrator"
                            disabled={childEligibleParent?.length === 0 ? true : false}
                            options={childEligibleParent}
                        />
                    </div>
                </div>
                <div className="grid grid-cols-12 gap-3">
                    {!uuid ? <div className="col-span-4">
                        <InputComponent label="Senha" name="password" id="password" />
                    </div> : <></>}
                </div>
            </ContentBox>

            <div className="grid grid-cols-12 gap-4">
                <div className="col-span-4">
                    <Permission permissionKeys={[PermissionAuthority.GET]} fallback={<PermissionComponent />}>
                        <ContentBox className="p-6">
                            <div className="flex flex-col gap-3 perfil-container">
                                {sortedItems && sortedItems.map((group: any) => (
                                    <div className="cursor-pointer flex gap-2 items-center" key={group} onClick={() => handleGroupClick(group)}>
                                        <div className={`rounded w-6 flex items-center justify-center text-sm ${countItemsInGroup(group) > 0 ? 'bg-primary-color text-white' : 'bg-gray-200 text-black'
                                            }`}>
                                            {countItemsInGroup(group)} {/* Contador de itens */}
                                        </div>
                                        <p className="text-sm">{group}</p>
                                    </div>
                                ))}
                            </div>
                        </ContentBox>
                    </Permission>
                </div>
                <div className="col-span-8">
                    <Permission permissionKeys={[PermissionAuthority.GET]} fallback={<PermissionComponent />}>
                        <ContentBox className="p-6" title={permissions && permissions[0]?.groupedBy} description='Selecione um Grupo de Permissões para visualizar as autorizações na listagem a baixo'>
                            <div className="flex flex-col gap-2 permissions-list">
                                {sortedItemsPermission && sortedItemsPermission.map((item: any, index: number) => (
                                    <div className="flex gap-2" key={index}>
                                        <CheckboxComponent disabled={true} label={`${item.description} (${item.action})`} key={item.uuid} onChange={() => console.log()} checked={selectedItems.some((selected: any) => selected?.uuid === item.uuid)} />
                                        {selectedItems.some((selected: any) => selected.uuid === item.uuid && selected.source) && (
                                            <Tag color="green">Permissão de Grupo</Tag>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </ContentBox>
                    </Permission>
                </div>
            </div>
        </>
    );
});

export default FormAdministrator;
